
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard, AppSelect } from '@/components';
import useGoogleLinkedapp from '@/modules/google/model/linkedapp';
import { ROUTE_NAME_GOOGLE } from '@/modules/google/router';

export default defineComponent({
    name: ROUTE_NAME_GOOGLE.LINKED_APP,
    components: { AppFormRow, AppInput, AppButton, AppCard, AppSelect },
    setup() {
        const { model, v$, fetch, actions } = useGoogleLinkedapp();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
